module.exports = __webpack_public_path__ + "img/20220411_131921.a65bc7b1.jpg";